const secrets = {
    third_party_token_set: {
        token_not_found: 'Запись токена не найдена.',
        access_token_expired: 'Срок действия токена доступа истек. Пожалуйста, переподключите ваш аккаунт.',
    },
};
export default Object.freeze(secrets);
